const getCurrentYear = () => {
  return new Date().getFullYear();
};

export const DefaultCallendlyName = "Alejandro Losa";

export default getCurrentYear;
